export default "__VITE_ASSET__CT_byoC2__"